module.exports = __webpack_public_path__ + "static/media/load_5.effa1206.gif";